module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/icon/park-db91e1af06a7938c4d3966d1eec51578.svg&quot;;"